import React from 'react'
import { Link as MuiLink } from '@mui/material'

import { Link as RouterLink } from 'react-router-dom'

export interface LinkRouterProps {
  to: string
  className?: string
  disabled?: boolean
  dataQa?: string
  children?: React.ReactNode
  onClick?: () => void
}

const LinkRouter: React.FC<LinkRouterProps> = ({ to, className, children, disabled, dataQa, onClick }) => {
  if (disabled) return <>{children}</>
  const protocolRegex = new RegExp('(http://){1}|(https://){1}')
  const isExternalLink = protocolRegex.test(to)
  return (
    <>
      {isExternalLink ? (
        <MuiLink className={className} component="a" target="_blank" rel="noopener noreferrer" href={to} data-qa={dataQa} onClick={onClick}>
          {children}
        </MuiLink>
      ) : (
        <MuiLink component={RouterLink} to={to} className={className} data-qa={dataQa} onClick={onClick}>
          {children}
        </MuiLink>
      )}
    </>
  )
}

export default LinkRouter
